import React from "react";

const Delivery = () => {
    return (
        <></>
    )
} 
export default Delivery;